function injectStyle (ssrContext) {
  require("!!../../node_modules/.pnpm/extract-text-webpack-plugin@3.0.2_webpack@3.12.0/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-42e20ab3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/selector?type=styles&index=0!./Markerinfo.vue")
}
var normalizeComponent = require("!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/selector?type=script&index=0!./Markerinfo.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/selector?type=script&index=0!./Markerinfo.vue"
/* template */
import __vue_template__ from "!!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-42e20ab3\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-cor_d99c2e67b7b32d18d0753d3ff17efa83/node_modules/vue-loader/lib/selector?type=template&index=0!./Markerinfo.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e20ab3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Markerinfo.vue
// module id = null
// module chunks = 